import axios from '../../api';

const BASE = process.env.REACT_APP_URL;

export const getSupplierBarang = (params = {}) =>
  axios.get(`${BASE}/supplier-barang`, {
    params: {
      page: params.page || 1,
      limit: params.limit || 10,
      search: params.search,
    },
  });

// Pembelian dikelompokkan per penerima bantuan (untuk supplier yang login)
export const getPembelianByPenerima = (params = {}) =>
  axios.get(`${BASE}/supplier-pembelian-penerima`, {
    params: {
      page: params.page || 1,
      limit: params.limit || 10,
      search: params.search,
    },
  });

export const getSupplierBarangById = (id) =>
  axios.get(`${BASE}/supplier-barang/${id}`);

export const createSupplierBarang = (payload) =>
  axios.post(`${BASE}/supplier-barang`, payload);

export const updateSupplierBarang = (id, payload) =>
  axios.put(`${BASE}/supplier-barang/${id}`, payload);

export const deleteSupplierBarang = (id) =>
  axios.delete(`${BASE}/supplier-barang/${id}`);

export const addDetailTransaksi = (payload) =>
  axios.post(`${BASE}/supplier-detail`, payload);

// Data supplier milik sendiri (POS)
export const getMySupplierBarang = (params = {}) =>
  axios.get(`${BASE}/my-supplier-barang`, {
    params: {
      page: params.page || 1,
      limit: params.limit || 100,
      SupplierBarangId: params.SupplierBarangId,
    },
  });

// Tambah pembelian baru ke supplier existing (POS) — FormData upload foto
export const createPembelian = (formData) =>
  axios.post(`${BASE}/supplier-pembelian`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

// ===== Alur supplier =====
export const getPembelianById = (id) =>
  axios.get(`${BASE}/supplier-pembelian/${id}/detail`);

export const updateItemsDikirim = (id, itemIds) =>
  axios.put(`${BASE}/supplier-pembelian/${id}/items`, { itemIds });

export const updatePengiriman = (id, formData) =>
  axios.put(`${BASE}/supplier-pembelian/${id}/pengiriman`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

export const mintaPenagihan = (id) =>
  axios.post(`${BASE}/supplier-pembelian/${id}/penagihan`);

export const updatePembayaran = (id, statusPembayaran) =>
  axios.put(`${BASE}/supplier-pembelian/${id}/pembayaran`, { statusPembayaran });

export const getBuktiTransferMonitoring = () =>
  axios.get(`${BASE}/supplier-monitoring/bukti-transfer`);

export const getMonitoringPenagihan = (params = {}) =>
  axios.get(`${BASE}/supplier-penagihan`, { params });

// ===== Pengiriman Batch (multiple delivery) =====
export const getBatches = (pembelianId) =>
  axios.get(`${BASE}/pengiriman-batch/${pembelianId}`);
export const createBatch = (pembelianId, itemIds) =>
  axios.post(`${BASE}/pengiriman-batch/${pembelianId}`, { itemIds });
export const updateBatch = (batchId, formData) =>
  axios.put(`${BASE}/pengiriman-batch/${batchId}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
export const mintaPenagihanBatch = (batchId) =>
  axios.post(`${BASE}/pengiriman-batch/${batchId}/penagihan`);
export const updatePembayaranBatch = (batchId, statusPembayaran) =>
  axios.put(`${BASE}/pengiriman-batch/${batchId}/pembayaran`, { statusPembayaran });

export default {
  getSupplierBarang,
  getSupplierBarangById,
  createSupplierBarang,
  updateSupplierBarang,
  deleteSupplierBarang,
  addDetailTransaksi,
  getMySupplierBarang,
  createPembelian,
  updateItemsDikirim,
  updatePengiriman,
  mintaPenagihan,
  updatePembayaran,
  getBuktiTransferMonitoring,
};
